import React from 'react';

export default function Nemu() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H19.2C23.6804 0 25.9206 0 27.6319 0.871948C29.1372 1.63893 30.3611 2.86278 31.1281 4.36808C32 6.07937 32 8.31958 32 12.8V19.2C32 23.6804 32 25.9206 31.1281 27.6319C30.3611 29.1372 29.1372 30.3611 27.6319 31.1281C25.9206 32 23.6804 32 19.2 32H12.8C8.31958 32 6.07937 32 4.36808 31.1281C2.86278 30.3611 1.63893 29.1372 0.871948 27.6319C0 25.9206 0 23.6804 0 19.2V12.8Z'
        fill='url(#paint0_linear_5201_5282)'
      />
      <path
        d='M9.89236 22.5535L7 21.2166V10.8124L9.89236 9.38838V22.5535Z'
        fill='url(#paint1_linear_5201_5282)'
      />
      <path
        d='M10.8752 22.5535H10.4821L19.0468 5.02906V9.38838L10.8752 22.5535Z'
        fill='url(#paint2_linear_5201_5282)'
      />
      <path
        d='M25 7.5284L19.5523 5V27L25 24.4716V7.5284Z'
        fill='url(#paint3_linear_5201_5282)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_5201_5282'
          x1='16'
          y1='0'
          x2='16'
          y2='32'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#6266F5' />
          <stop offset='1' stop-color='#3035F2' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_5201_5282'
          x1='6.86092'
          y1='0.479724'
          x2='23.7338'
          y2='20.7146'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_5201_5282'
          x1='6.86092'
          y1='0.479724'
          x2='23.7338'
          y2='20.7146'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_5201_5282'
          x1='6.86092'
          y1='0.479724'
          x2='23.7338'
          y2='20.7146'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
      </defs>
    </svg>
  );
}
